// 端内通用跳转
import { forward, switch_page } from "@kk/h5-sdk";
export const commonAction = ({ actionType, actionUrl = "", actionId = 0 }) => {
    // 跳转页面 1-h5 18-hybrid
    if (actionType === 1 || actionType === 18) return forward({
        totype: "h5",//跳转方式：native,h5,hybrid,mall
        topage: actionUrl,
        todata: {},
    });
    // 跳转客户端内
    // 2-专题页
    if (actionType === 2) return forward({
        totype: "native",
        topage: "loadtopic/0",
        todata: {id: actionId},
    });
    // 3-漫画页
    if (actionType === 3) return forward({
        totype: "native",
        topage: "loadcomicdetail",
        todata: {id: actionId},
    });
    // 15 发现页-vip
    if (actionType === 15) return switch_page({
        action_type: 15,
        extra_params: { target_id: 40 }
    });
    // 43 会员开通页
    if (actionType === 43) return forward({
        totype: "native",
        topage: "load_open_member",
        todata: {},
    });
    // 44 会员中心
    if (actionType === 44) return forward({
        totype: "native",
        topage: "load_member_center",
        todata: {},
    });
    // 21 我的钱包
    if (actionType === 21) return forward({
        totype: "native",
        topage: "mine/wallet",
        todata: {},
    });
    // 22 kkb充值中心
    if (actionType === 22) return forward({
        totype: "native",
        topage: "mine/wallet/rechargecenter",
        todata: {},
    });
    // 58 KKB—短信充值
    if (actionType === 58) return switch_page({
        action_type: 58
    });
    




};


// WEBPACK FOOTER //
// ./src/assets/fe_js/common/base/jump/commonAction.js